import React, { useState } from "react";
import ArrowRight from "@material-ui/icons/ArrowRight";
import ArrowDown from "@material-ui/icons/ArrowDropDown";
import check from "../assets/svg/Dashboard/check-circle-regular.svg";

function Dropdown({ title, items = [], handleClick, isItemSelected }) {
  const [open, setOpen] = useState(false);
  const toggel = () => {
    setOpen(!open);
  };

  return (
    <div
      className={
        title === "حدد محافظتك"
          ? "mx-2 my-3 bg-n-blue  border-2 rounded-lg  w-64 focus:outline-none"
          : "mx-2 my-3 w-64  border-2 rounded-lg focus:outline-none "
      }
    >
      <div
        className=" flex  justify-between items-center  n-blue  px-4  focus:outline-none"
        tabIndex={0}
        role="button"
        onKeyPress={toggel}
        onClick={toggel}
      >
        <div className=" ">
          <p className={title === "حدد محافظتك" ? "text-white " : "n-blue"}>
            {title}
          </p>
        </div>

        {open ? (
          <ArrowDown alt="arrow" style={{ fontSize: 40 }} />
        ) : (
          <ArrowRight
            alt="arrow"
            style={{
              fontSize: 40,
              color: title === "حدد محافظتك" ? "white" : "n-blue",
            }}
          />
        )}
      </div>
      {open && (
        <div className=" h-32 overflow-y-scroll scrolling-touch overflow-x-hidden z-50 scrollbar-thumb">
          <ul className="border-2 n-blue w-64 bg-white">
            {items.map((item) => {
              return (
                <li
                  key={item.id}
                  className="border-b-2 n-blue w-64 px-4 py-2 focus:outline-none"
                >
                  <div
                    type="button"
                    onClick={() => handleClick(item)}
                    className="w-56 flex justify-between cursor-pointer"
                  >
                    <span className=" ">{item.value}</span>
                    <span>
                      {isItemSelected(item) && (
                        <img src={check} alt="arrow" className="pr-2 w-6" />
                      )}
                    </span>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}
export default Dropdown;
